module.exports = __webpack_public_path__ + "static/media/innopayD.2868faaa.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/innopayD.svg
// module id = 385
// module chunks = 7